// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1XEY5s3CBd9NTH1h7Ump2a","shareLabel":"_1VnkC3ZL4beYXmLGdudFaz","snsShare":"_2Zj5HUKoOT5BV5YRa7KIb8","pinterestShare":"_2IaYNmf1OwnFyeIh_F1_TS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-footer/ContentFooter.css
// module id = 384
// module chunks = 0